import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaTelegramPlane } from "react-icons/fa";
import { ChevronDown, ClipboardList, LayoutDashboard, LogIn, Menu as MenuIcon, Moon, ShoppingBag, Sun, Wallet, X } from "lucide-react";
import { useAuth } from "../lib/auth";

export const Header = ({ settings }) => {
  const [open, setOpen] = useState(false);
  const [nightMode, setNightMode] = useState(false);
  const { user } = useAuth();
  const isCustomer = user && user !== false && user.role !== "admin";
  const initials = (user?.name || user?.email || "AZ").trim().slice(0, 1).toUpperCase();
  const telegram = settings?.telegram_link || "#";

  const toggleTheme = () => {
    const nextMode = !nightMode;
    setNightMode(nextMode);
    document.documentElement.classList.toggle("panel-night", nextMode);
  };

  return (
    <header data-testid="site-header" className="site-header">
      <div className="site-header-inner">
        <button
          data-testid="header-menu-toggle"
          type="button"
          className="header-icon-button menu-toggle"
          onClick={() => setOpen((value) => !value)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          {open ? <X /> : <MenuIcon />}
        </button>

        <Link to="/" data-testid="logo-link" className="brand-lockup" onClick={() => setOpen(false)}>
          <span className="brand-mark">AZ</span>
          <span className="brand-copy"><strong>AZMIEY STORE</strong><small>Booster Sosial</small></span>
        </Link>

        <nav className="header-actions" aria-label="Account navigation">
          <span className="currency-chip">MYR RM <ChevronDown /></span>
          <a data-testid="header-telegram-btn" className="header-icon-button telegram-button" href={telegram} target="_blank" rel="noreferrer" aria-label="Telegram">
            <FaTelegramPlane />
          </a>
          <button type="button" className="header-icon-button theme-button" onClick={toggleTheme} aria-label={nightMode ? "Use light theme" : "Use dark theme"} title={nightMode ? "Light theme" : "Dark theme"}>
            {nightMode ? <Sun /> : <Moon />}
          </button>
          <Link to={isCustomer ? "/dashboard" : "/login"} data-testid="header-avatar" className="user-avatar" aria-label={isCustomer ? "Account dashboard" : "Sign in"}>
            {isCustomer ? initials : <LogIn />}
          </Link>
        </nav>
      </div>

      {open && (
        <nav className="header-menu" aria-label="Main menu">
          {isCustomer ? (
            <>
              <Link to="/dashboard" onClick={() => setOpen(false)}><LayoutDashboard /> Dashboard</Link>
              <Link to="/topup" onClick={() => setOpen(false)}><Wallet /> Top up</Link>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)}><LogIn /> Sign in</Link>
              <Link to="/register" onClick={() => setOpen(false)}><ShoppingBag /> Create account</Link>
            </>
          )}
          <Link to="/orders" onClick={() => setOpen(false)}><ClipboardList /> Orders</Link>
          <a href={telegram} target="_blank" rel="noreferrer" onClick={() => setOpen(false)}><FaTelegramPlane /> Telegram</a>
        </nav>
      )}
    </header>
  );
};

export default Header;